module.exports = __webpack_public_path__ + "public/files/img/users.48152a6c.png";